export const AFFLICTION_LEVEL = [
    0,
    1,
    2
];